import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";

const POLL_MS = 60000; // check every 60s

export const useKickStatus = () => {
  const [status, setStatus] = useState({ isLive: false, title: "", viewers: 0 });

  useEffect(() => {
    let mounted = true;
    const fetchStatus = async () => {
      try {
        const r = await axios.get(`${API}/kick/status`);
        if (mounted) setStatus(r.data);
      } catch (e) {
        // keep last known status on error
      }
    };
    fetchStatus();
    const t = setInterval(fetchStatus, POLL_MS);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  return status;
};
